module.exports = __webpack_public_path__ + "static/media/DeleteBin.88a34e4c.svg";